import { render, staticRenderFns } from "./SubjectsScales.vue?vue&type=template&id=84af21d2"
import script from "./SubjectsScales.vue?vue&type=script&lang=js"
export * from "./SubjectsScales.vue?vue&type=script&lang=js"
import style0 from "./SubjectsScales.vue?vue&type=style&index=0&id=84af21d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports